import {
  Component,
  Input,
  input,
  output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { containerNames } from "../../../shared/container/container.const";
import { FormatContainerLabelPipe } from "../../../shared/container/format-container-label.pipe";
import { ContainerName } from "../../../shared/container/container-name.type.const";
import { Bind } from "primeng/bind";
import { Select } from "primeng/select";
import { SelectedChipsComponent } from "../../chip/selected-chips.component";
import { Checkbox } from "primeng/checkbox";
import { FormsModule } from "@angular/forms";

@Component({
  selector: "app-container-select",
  templateUrl: "./container-select.component.html",
  styleUrls: ["./container-select.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Bind, Select, Checkbox, FormsModule, SelectedChipsComponent],
})
export class ContainerSelectComponent {
  @Input() label = "Containers";
  readonly appendTo = input("body");
  readonly disabled = input(false);
  readonly required = input(false);
  // Hold the error state back until the user has opened the select once, so a
  // fresh form does not open with a red field.
  readonly validateOnTouch = input(false);
  public touched = false;
  @Input() selectedContainers: ContainerName[] = [];
  readonly selectionChange = output<ContainerName[]>();

  public containerList = containerNames.map((containerName) => ({
    label: new FormatContainerLabelPipe().transform(containerName),
    value: containerName,
  }));

  constructor() {}

  onContainersChange() {
    this.touched = true;
    this.selectionChange.emit(this.getSortedSelection());
  }

  public hasError(): boolean {
    if (!this.required() || this.selectedContainers?.length) {
      return false;
    }

    return this.touched || !this.validateOnTouch();
  }

  public readonly chipLabel = (container: ContainerName): string =>
    this.getContainerLabel(container);

  public removeContainer(container: ContainerName) {
    this.selectedContainers = (this.selectedContainers ?? []).filter(
      (item) => item !== container,
    );
    this.onContainersChange();
  }

  public isSelected(container: ContainerName): boolean {
    return (this.selectedContainers ?? []).includes(container);
  }

  public getContainerLabel(container: ContainerName): string {
    return (
      this.containerList.find((item) => item.value === container)?.label ?? ""
    );
  }

  private getSortedSelection(): ContainerName[] {
    const sortedList: ContainerName[] = [];
    this.containerList.map((element) => {
      if (this.selectedContainers.indexOf(element.value) !== -1) {
        sortedList.push(element.value);
      }
    });

    return sortedList;
  }
}
